export const RequestAccessButtons = {
  flow: 'y',
  align: 'start start',
  // Fill-contrast column divider (was a left-edge `line` border — border-
  // habit sweep, design-direction.md §8) separating this OAuth column from
  // the email/password form beside it in LoginWindow's two-column Flex.
  background: 'overlay',
  margin: '0',
  '@media (max-width: 500px)': {
    // Stacked single-column layout on mobile — no sibling column to
    // separate from, so no fill either (matches the original border's
    // desktop-only intent).
    background: 'transparent',
    padding: 'A 0 0',
    align: 'center flex-start'
  },
  childProps: {
    width: '100%'
  },
  Hgroup: {
    H: {
      tag: 'strong',
      text: '{{ members.requestAccess.title | polyglot }}'
    },
    P: {
      text: '{{ members.requestAccess.body | polyglot }}'
    }
  },
  Flex: {
    flow: 'y',
    gap: 'A2',
    '@media (max-width: 500px)': {
      gap: 'Z'
    },
    Link: {
      extends: ['Link', 'Button'],
      icon: 'email',
      Icon: { order: '-1' },
      margin: '0 0 0 -X',
      theme: 'quaternary',
      // Adaptive (was fixed 'white') — `theme: 'quaternary'` already supplies
      // its own paired text color; the fixed override defeated it and went
      // invisible against quaternary's near-white light-mode background.
      color: 'title',
      fontWeight: '500',
      text: '{{ members.requestAccess.continueEmail | polyglot }}',
      href: '/signin',
      gap: 'Z',
      '@tabletS': {
        align: 'center center',
        fontSize: 'Z1',
        margin: '0',
        maxWidth: '100%',
        padding: 'Z1 A',
        width: '100%'
      },
      '@media (max-width: 500px)': {
        align: 'center center',
        maxWidth: '100%',
        textAlign: 'center',
        border: 'none'
      },
      '@mobileM': {
        fontSize: 'Y'
      }
    }
  }
}
